import React, { Component } from "react";
import { Link } from "react-router-dom";
import { PRODUCT_IMAGE_BASE_URL, CALCULATOR_API } from "../constants";
import IconInfo from "../components/IconInfo";
import { connect } from "react-redux";
import { addQuoteItem } from "../redux/actions";
import style from "./UniflowCalculator.module.css";
import { OnBlurInput } from "../components/OnBlurInput";
import { Button } from "react-bootstrap";

class UniflowCalculator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      manualSoftwareUrl: "#",
      hasPrintServer: false,
      isLoading: false,
      isSuccess: false,
      errorMessage: "",
      totalAddedQty: 0
    };
  }

  handleFormSubmit = async e => {
    e.preventDefault();

    this.setState({
      isLoading: true,
      isSuccess: false,
      errorMessage: "",
      totalAddedQty: 0
    });

    try {
      const searchParams = new URLSearchParams(new FormData(e.target));
      const url = `${CALCULATOR_API}?${searchParams.toString()}`;
      const response = await fetch(url);
      const jsonResponse = await response.json();

      if (jsonResponse.has_error === 1) {
        this.setState({ errorMessage: jsonResponse.message });
        return;
      }

      jsonResponse.items.forEach(product =>
        this.props.addQuoteItem({
          productId: product.id,
          sku: product.sku,
          name: product.name,
          price: product.price,
          image: product.image ? PRODUCT_IMAGE_BASE_URL + product.image : null,
          qty: product.qty,
          type: "simple"
        })
      );

      this.setState({
        isSuccess: true,
        totalAddedQty: jsonResponse.total_qty
      });
    } catch (e) {
      this.setState({ errorMessage: e.message });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    return (
      <div className="uniflowcalculator_container calculator_container">
        <div className="container">
          {this.state.manualSoftwareUrl !== "#" && (
            <h3>
              <span className="add_software_link">
                Configure &amp; add software to quote
                <Link
                  className="right stylelink"
                  to={this.state.manualSoftwareUrl}
                >
                  Add individual software
                </Link>
              </span>
            </h3>
          )}
          <hr className="style1" />
          <h5>
            Complete the following questions to configure software solutions to
            add to quote
          </h5>
          <br />
          {this.state.errorMessage && (
            <div className="messages-block">
              <ul class="messages">
                <li class="error-msg">
                  <ul>
                    <li>
                      <span>{this.state.errorMessage}</span>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          )}
          <form
            action="/calculator/index/processQuestionnaire"
            id="calculator_questionnaire_form"
            method="post"
            onSubmit={this.handleFormSubmit}
          >
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <td>
                    How many staff does the company have?
                    <div className={style.tooltip}>
                      <IconInfo />
                      <div className={style.tooltipText}>
                        Please enter the total number of users who need to be
                        able to print?
                        <br />
                        <br />
                        Must be no more than 500
                      </div>
                    </div>
                  </td>
                  <td>
                    <OnBlurInput
                      type="number"
                      id="numberOfStaff"
                      name="numberOfStaff"
                      value=""
                      placeholder="# of staff"
                      min="1"
                      max="500"
                      required={true}
                    />
                  </td>
                </tr>
                <tr>
                  <td>How long is the contract term?</td>
                  <td>
                    <select id="month" name="month" defaultValue="12">
                      <option value="12">12 months</option>
                      <option value="24">24 months</option>
                      <option value="36">36 months</option>
                      <option value="48">48 months</option>
                      <option value="60">60 months</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    How many devices will be using the software?
                    <div className={style.tooltip}>
                      <IconInfo />
                      <div className={style.tooltipText}>
                        Please enter the total number of imageRUNNER ADVANCE
                        (MEAP Enabled) devices
                        <br />
                        <br />
                        Must be no more than 10
                      </div>
                    </div>
                  </td>
                  <td>
                    <OnBlurInput
                      type="number"
                      id="numberOfDevice"
                      name="numberOfDevice"
                      size="30"
                      min="1"
                      max="10"
                      value=""
                      placeholder="# of devices (up to 10)"
                      required={true}
                    />
                  </td>
                </tr>
                <tr className="printserver">
                  <td>Does the company have printer server infrastructure?</td>
                  <td>
                    <input
                      id="hasPrintServerYes"
                      name="hasPrintServer"
                      type="radio"
                      value="1"
                      checked={this.state.hasPrintServer}
                      onChange={() => this.setState({ hasPrintServer: true })}
                    />
                    <label htmlFor="hasPrintServerYes">Yes</label>
                    &nbsp;&nbsp;&nbsp;
                    <input
                      id="hasPrintServerNo"
                      name="hasPrintServer"
                      type="radio"
                      value="0"
                      checked={!this.state.hasPrintServer}
                      onChange={() => this.setState({ hasPrintServer: false })}
                    />
                    <label htmlFor="hasPrintServerNo">No</label>
                  </td>
                </tr>
                {this.state.hasPrintServer && (
                  <tr className="printserver">
                    <td>&nbsp;</td>
                    <td>
                      <OnBlurInput
                        type="number"
                        id="numberOfPrintServer"
                        name="numberOfPrintServer"
                        value=""
                        min="1"
                        placeholder="# of print servers"
                        required={true}
                      />
                    </td>
                  </tr>
                )}
                <tr>
                  <td>
                    Is mobile print ability required?
                    <div className={style.tooltip}>
                      <IconInfo />
                      <div className={style.tooltipText}>
                        Select this to enable mobile printing via email.
                      </div>
                    </div>
                  </td>
                  <td>
                    <input
                      id="requireMobilePrintyes"
                      name="requireMobilePrint"
                      type="radio"
                      value="1"
                    />
                    <label htmlFor="requireMobilePrintyes">Yes</label>
                    &nbsp;&nbsp;&nbsp;
                    <input
                      id="requireMobilePrintno"
                      name="requireMobilePrint"
                      type="radio"
                      value="0"
                      defaultChecked={true}
                    />
                    <label htmlFor="requireMobilePrintno">No</label>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <input name="calculator_uid" type="hidden" value="AU_Uniflow" />
            <Button
              id="calculator-submit-button"
              name="submit"
              type="submit"
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? "Processing..." : "Add to quote"}
            </Button>
            {this.state.manualSoftwareUrl !== "#" && (
              <span className="manual_software_link">
                <Link to={this.state.manualSoftwareUrl}>
                  Manual quote click here
                </Link>
              </span>
            )}
          </form>
        </div>

        {this.state.isSuccess && (
          <div className="add_to_quote_success_modal">
            <div className="modal-overlay success_popup_inner">
              <div className="content">
                <div className="heading">
                  Product has been added to you quote
                </div>
                <div className="item success_msg_container">
                  {this.state.totalAddedQty} products
                </div>
                <div className="cta">
                  <Button
                    className="add"
                    onClick={() => {
                      window.location.assign("/");
                    }}
                  >
                    <span>+</span> Add more products
                  </Button>
                  <Button
                    className="view"
                    onClick={() => {
                      window.location.assign("/quote");
                    }}
                  >
                    View quote
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(null, { addQuoteItem })(UniflowCalculator);
